import PropTypes from 'prop-types';

import {Textbox} from 'fabric';
import {useTextStore} from 'module/text';

import {limitReached} from '../canvas-helper';

export const defaultWordJoiners = Textbox.prototype._wordJoiners;

const Text = ({canvas, stroke}) => {
    canvas.on('mouse:down', (o) => {
        if (limitReached(canvas)) {
            return;
        }

        // don't draw if an object is selected on the canvas
        if (canvas.getActiveObject()) {
            return;
        }

        let pointer = canvas.getScenePoint(o.e);

        const txt = new Textbox('', {
            custom: {
                type: 'text'
            },
            left: pointer.x,
            top: pointer.y,
            strokeWidth: 1,
            stroke,
            fill: stroke,
            fontSize: 40,
            fontFamily: 'inter',
            hasBorders: true,
            hasControls: true
        });

        canvas.add(txt);
        canvas.setActiveObject(txt);
        canvas.renderAll();
        
        // Open the text dialog for editing
        useTextStore.getState().set(txt);
    });
};

Text.propTypes = {
    canvas: PropTypes.object.isRequired,
    stroke: PropTypes.string
};

export default Text;